import type { FreelancerLoginLocales } from '../types';

const freelancerLoginLocales: FreelancerLoginLocales = {
  loginError: 'Error bij het inloggen',
  loginSuccess: 'Je bent ingelogd!',
  passwordForgotten: 'Wachtwoord Vergeten',
  title: 'Log in',
};

export default freelancerLoginLocales;
